var map = {
	"./automated-material-flow.svg": 1221,
	"./check.gif": 407,
	"./checked.svg": 1222,
	"./data-driven-maintenance.svg": 1223,
	"./digital-organisation.svg": 1224,
	"./digital-ready-infrastructure.svg": 1225,
	"./factory-future-leadership.svg": 1226,
	"./factory-visibility.svg": 1227,
	"./hour-1.svg": 624,
	"./hover-remove-btn.svg": 1228,
	"./hover-resend-btn.svg": 1229,
	"./industry-introduction.svg": 1230,
	"./intelligent-quality.svg": 1231,
	"./invite-img-wrap.svg": 630,
	"./invite.svg": 1232,
	"./locked-img.svg": 1233,
	"./open-tab-icon.svg": 408,
	"./q-clock.svg": 625,
	"./q-completed-img.svg": 628,
	"./q-maturity.svg": 627,
	"./q-over.svg": 626,
	"./quick-beta-card-img.svg": 1234,
	"./resend.svg": 1235,
	"./sustainability.svg": 1236,
	"./tech-augmented-workforce.svg": 1237,
	"./unlock-red.svg": 1238,
	"./unlocked-img.svg": 1239,
	"./zero-touches-production.svg": 1240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 629;